import { useLeadsFunnelsPage } from '../hooks';

import { LeadsFunnelBoard } from './components/LeadsFunnelBoard';
import { LeadsFunnelSelectorState } from './components/LeadsFunnelSelectorState';

import type { FC } from 'react';

import './LeadsFunnelsPage.scss';

export const LeadsFunnelsPage: FC = () => {
  const {
    board,
    dnd,
    funnels,
    hasMoreLeads,
    hasSelectedFunnel,
    isInitialLoading,
    isLoadingMore,
    onLoadMore,
    onSalesFunnelChange,
    onScroll,
    selectedFunnelId,
  } = useLeadsFunnelsPage();

  return (
    <section className="LeadsFunnelsPage">
      <div className="LeadsFunnelsPage__scroll" onScroll={onScroll}>
        {hasSelectedFunnel ? (
          <LeadsFunnelBoard
            board={board}
            dnd={dnd}
            hasMoreLeads={hasMoreLeads}
            isInitialLoading={isInitialLoading}
            isLoadingMore={isLoadingMore}
            onLoadMore={onLoadMore}
          />
        ) : (
          <LeadsFunnelSelectorState
            funnels={funnels}
            selectedFunnelId={selectedFunnelId}
            onChange={onSalesFunnelChange}
          />
        )}
      </div>
    </section>
  );
};
